import React from "react";
import { connect } from 'react-redux';
import { useQuery } from "react-query";
import { useQueryClient } from "react-query";

import { fetchSAVFournisseursDepots, fetchSAVDepotsGestion } from 'utils/queries';

import { postSAVFournisseurDepot, postSAVFournisseurDepots, deleteSAVFournisseurDepot, deleteSAVFournisseurDepots } from 'utils/posters';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import FournisseurGestionAutocomplete from 'components/Shared/FournisseurGestionAutocomplete';
import LoadingButton from 'components/Shared/LoadingButton';
import SkeletonTable from 'components/Shared/SkeletonTable';

import QualificationTextField from 'components/Shared/QualificationTextField';

import { EmailValidationRegex } from 'constants.js';


const filter = createFilterOptions(); // Filtre pour l'édition d'un email

const defaultFournisseurDepot = {
    fournisseur: { id: 0 },
    depot: { codeDepot: "" },
    newEmail: "",
    newNumeroCompte: "",
    newCodeAgence: ""
};

const actionsCellStyle = { wordWrap: "break-word", width: "100px" };

const FournisseursDepots = ({ postSAVFournisseurDepot, postSAVFournisseurDepots, deleteSAVFournisseurDepot, deleteSAVFournisseurDepots }) => {

    const [edited, setEdited] = React.useState(defaultFournisseurDepot);
    const [saving, setSaving] = React.useState(false);

    const [anchorMenuFournisseur, setAnchorMenuFournisseur] = React.useState(null);
    const menuFournisseurOpen = Boolean(anchorMenuFournisseur);

    const [anchorMenuDepot, setAnchorMenuDepot] = React.useState(null);
    const menuDepotOpen = Boolean(anchorMenuDepot);

    const [removeFournisseurDialogOpen, setRemoveFournisseurDialogOpen] = React.useState(false);
    const [addFournisseurDialogOpen, setAddFournisseurDialogOpen] = React.useState(false);

    // Hook récupération des données du tableau
    const queryClient = useQueryClient();
    const fournisseursDepotsQuery = useQuery(["SAVFournisseursDepots"], fetchSAVFournisseursDepots);
    const depotsQuery = useQuery(["SAVDepotsGestion"], fetchSAVDepotsGestion);

    const [fournisseurFiltre, setFournisseurFiltre] = React.useState(null);
    const [fournisseurToRemove, setFournisseurToRemove] = React.useState(null);
    const [fournisseurToAdd, setFournisseurToAdd] = React.useState(null);

    const [depotFiltre, setDepotFiltre] = React.useState(null);

    const [tousDepots, setTousDepots] = React.useState(false);
    const [manquants, setManquants] = React.useState(false);

    // Initialisation du filtre fournisseur
    React.useEffect(() => {
        if (!fournisseursDepotsQuery.isLoading
            && !fournisseursDepotsQuery.error
            && fournisseursDepotsQuery.data.fournisseurs
            && fournisseursDepotsQuery.data.fournisseurs.length > 0
            && fournisseurFiltre === null
            && depotFiltre === null
        ) {
            setFournisseurFiltre(fournisseursDepotsQuery.data.fournisseurs[0]);
        }
    }, [fournisseursDepotsQuery.data]);


    // Memorisation des liaisons fournisseurs dépots
    const fournisseursDepots = React.useMemo(() => {

        let _fournisseursDepots = [];

        if (fournisseursDepotsQuery && fournisseursDepotsQuery.data) {

            if (tousDepots || manquants || depotFiltre) {

                let depotsFournisseurs = depotsQuery.data
                    .filter(d => depotFiltre == null || d.codeDepot === depotFiltre.codeDepot)
                    .map(d => {
                        let depot = {
                            depot: { codeDepot: d.codeDepot, nom: d.nom },
                            fournisseursDepots: fournisseursDepotsQuery.data.fournisseursDepots
                                .filter(fd => fd.codeDepot === d.codeDepot)
                                .filter(fd => fournisseurFiltre == null || fd.fournisseurId === fournisseurFiltre.id)
                        };
                        return depot
                    });

                let outerJoin = depotsFournisseurs.map(depot => {

                    if (depot.fournisseursDepots.length > 0) {
                        if (!manquants) {
                            return depot.fournisseursDepots
                                .map(fd => {
                                    let fournisseur = fournisseursDepotsQuery.data.fournisseurs.find(f => f.id === fd.fournisseurId);
                                    let fournisseurDepot = {
                                        numeroCompte: fd.numeroCompte,
                                        email: fd.email,
                                        fournisseur,
                                        depot: depot.depot,
                                        codeAgence: fd.codeAgence
                                    };
                                    return fournisseurDepot;
                                });
                        }
                        return [];
                    }
                    else {
                        return fournisseursDepotsQuery.data.fournisseurs
                            .filter(f => fournisseurFiltre == null || f.id === fournisseurFiltre.id)
                            .map(f => {
                                let fournisseurDepot = {
                                    numeroCompte: '',
                                    email: '',
                                    fournisseur: f,
                                    depot: depot.depot,
                                    manquant: true,
                                    codeAgence: ''
                                };
                                return fournisseurDepot;
                            });
                    }

                });
                // Flatten and sort
                _fournisseursDepots = outerJoin.reduce((accumulator, currentValue) => accumulator.concat(currentValue), [])
                    .sort((a, b) => a.fournisseur.code !== b.fournisseur.code ? a.fournisseur.code > b.fournisseur.code : a.depot.codeDepot > b.depot.codeDepot);


                // Ajout des fournisseurs manquant lorsque l'on filtre sur un dépot
                if (depotFiltre && !fournisseurFiltre) {

                    var test = fournisseursDepotsQuery.data.fournisseurs.map(
                        fournisseur => {
                            let f = _fournisseursDepots.find(fd => fd.fournisseur.id === fournisseur.id);
                            if (f) { return f; }

                            let fournisseurDepot = {
                                numeroCompte: '',
                                email: '',
                                fournisseur: fournisseur,
                                depot: depotFiltre,
                                manquant: true,
                                codeAgence: ''
                            };
                            return fournisseurDepot;
                        }
                    );

                    _fournisseursDepots = test;
                }

            }
            else {
                _fournisseursDepots = fournisseursDepotsQuery.data.fournisseursDepots
                    .filter(fd => fournisseurFiltre == null || fd.fournisseurId === fournisseurFiltre.id)
                    .filter(fd => depotFiltre == null || fd.codeDepot === depotFiltre.codeDepot)
                    .map(fd => {
                        let fournisseur = fournisseursDepotsQuery.data.fournisseurs.find(f => f.id === fd.fournisseurId);
                        let depot = depotsQuery.data?.find(d => d.codeDepot === fd.codeDepot);
                        let fournisseurDepot = {
                            numeroCompte: fd.numeroCompte,
                            email: fd.email,
                            fournisseur,
                            depot,
                            codeAgence: fd.codeAgence
                        };
                        return fournisseurDepot;
                    });
            }
        }
        //console.log("Memorization fournisseursDepots", _fournisseursDepots);

        return _fournisseursDepots;

    }, [fournisseursDepotsQuery.data, depotsQuery.data, fournisseurFiltre, depotFiltre, tousDepots, manquants]);


    // Memorisation de la validité du tableau d'ajout de fournisseur
    const fournisseurToAddValid = React.useMemo(() => {

        if (!fournisseurToAdd || fournisseurToAdd.step !== 3) {

            return false;
        }

        let unicite = true;

        let index = 0;
        while (unicite && index < fournisseurToAdd.liaisons.length - 1) {
            let rang = index + 1;
            if (fournisseurToAdd.liaisons[index].numeroCompte) {
                while (unicite && rang < fournisseurToAdd.liaisons.length) {
                    unicite = fournisseurToAdd.liaisons[index].numeroCompte !== fournisseurToAdd.liaisons[rang++].numeroCompte;
                }
            }
            index++;
        }

        return unicite;

    }, [fournisseurToAdd]);


    // Memorisation des numéros de compte à contrôler
    const numerosComptes = React.useMemo(() => {

        let nums = []

        if (!edited.fournisseur.id && !edited.depot.codeDepot) {
            return nums;
        }

        let filtered = fournisseursDepotsQuery.data.fournisseursDepots.filter(x => x.fournisseurId === edited.fournisseur.id && x.codeDepot !== edited.depot.codeDepot && x.numeroCompte !== '');

        nums = filtered.map(x => { return { numeroCompte: x.numeroCompte, codeDepot: x.codeDepot } });

        return nums;
    }, [edited.fournisseur.id, edited.depot.codeDepot]);


    // Memorisation de la validité à l'édition d'une liaison fournisseur / depot
    const editedValid = React.useMemo(() => {

        let valid = { numeroCompte: false, email: false };

        if (edited.fournisseur.id && edited.depot.codeDepot) {
            valid.email = edited.newEmail !== '';
            if (valid.email) {
                valid.email = EmailValidationRegex.test(edited.newEmail);
                if (!valid.email) {
                    valid.emailHelperText = "Adresse email non valide";
                }
            }

            if (edited.newNumeroCompte === '' || edited.numeroCompte === edited.newNumeroCompte) {
                valid.numeroCompte = true;
            }
            else {
                let duplicate = numerosComptes.find(x => x.numeroCompte === edited.newNumeroCompte);

                if (duplicate) {
                    valid.numeroCompteHelperText = "Numéro de compte existant sur le dépôt " + duplicate.codeDepot;
                }
                else {
                    valid.numeroCompte = true;
                }

            }
        }
        return valid;

    }, [edited.newEmail, edited.newNumeroCompte]);


    const handeChangeTousDepot = () => {
        setDepotFiltre(null);
        setManquants(false);
        setTousDepots(!tousDepots);
    };

    const handeChangeManquants = () => {
        setDepotFiltre(null);
        setTousDepots(false);
        setManquants(!manquants);
    };

    const handeChangeDepotFiltre = (e) => {
        setTousDepots(false);
        setManquants(false);
        setDepotFiltre(depotsQuery.data.find(d => d.codeDepot === e.target.value));
    };

    const startEdition = (fournisseurDepot) => {
        setEdited(
            {
                ...fournisseurDepot,
                newNumeroCompte: fournisseurDepot.numeroCompte,
                newEmail: fournisseurDepot.email,
                newCodeAgence: fournisseurDepot.codeAgence
            }
        )
    };


    const setEditedMail = (value) => {
        setEdited({ ...edited, newEmail: value ? value.email : '' })
    };


    const validEdition = async () => {
        // console.log("saving", edited);
        setSaving(true);

        let newFournisseurDepot = { ...edited };
        if (edited.newNumeroCompte !== undefined) {
            newFournisseurDepot.numeroCompte = edited.newNumeroCompte;
        }
        if (edited.newEmail !== undefined) {
            newFournisseurDepot.email = edited.newEmail;
        }
        if (edited.newCodeAgence !== undefined) {
            newFournisseurDepot.codeAgence = edited.newCodeAgence;
        }

        var result = await postSAVFournisseurDepot(newFournisseurDepot);

        // console.log("validEdition", result);

        setSaving(false);

        if (result) {

            queryClient.resetQueries("SAVFournisseursDepots");
        }

        setEdited(defaultFournisseurDepot);
    };


    const handleRemovalFournisseur = async () => {
        if (fournisseurToRemove) {
            setSaving(true);

            var result = await deleteSAVFournisseurDepots(fournisseurToRemove);

            setSaving(false);

            if (result) {
                queryClient.resetQueries("SAVFournisseursDepots");
            }

            setRemoveFournisseurDialogOpen(false);
            setFournisseurToRemove(null);
        }
    };


    const handleRemovalFournisseurDepot = async (fournisseurDepot) => {
        if (fournisseurDepot &&
            fournisseurDepot.newEmail !== '' &&
            (fournisseurDepot.newEmail !== fournisseurDepot.email || fournisseurDepot.numeroCompte !== fournisseurDepot.newNumeroCompte)) {
            setSaving(true);

            var result = await deleteSAVFournisseurDepot(fournisseurDepot);

            setSaving(false);

            if (result) {
                queryClient.resetQueries("SAVFournisseursDepots"); // Voir pour juste supprimer la ligne
            }
        }

        setEdited(defaultFournisseurDepot);
    };


    const handleAdding = async () => {
        console.log("handleAdding", fournisseurToAdd);
        if (fournisseurToAdd && fournisseurToAddValid) {
            setSaving(true);

            var result = await postSAVFournisseurDepots(fournisseurToAdd);

            setSaving(false);

            if (result) {
                queryClient.resetQueries("SAVFournisseursDepots");
            }

            setAddFournisseurDialogOpen(false);
            setFournisseurToAdd(null);
        }
    };



    const openMenuFournisseur = (event) => {
        setAnchorMenuFournisseur(event.currentTarget);
    };
    const closeMenuFournisseur = () => {
        setAnchorMenuFournisseur(null);
    };

    const openMenuDepot = (event) => {
        setAnchorMenuDepot(event.currentTarget);
    };
    const closeMenuDepot = () => {
        setAnchorMenuDepot(null);
    };



    const handleChangeFournisseurToAdd = (selection) => {
        console.log("handleChangeFournisseurToAdd", selection);

        if (selection) {
            let duplicate = fournisseursDepotsQuery.data.fournisseurs.find(f => f.id === selection.id);

            setFournisseurToAdd({ ...selection, error: !!duplicate, step: 1, copier: '' });
        }
        else {
            setFournisseurToAdd(null);
        }
    };


    const handleAddFournisseurStep3 = () => {
        let newFournisseurToAdd = { ...fournisseurToAdd, step: 3 };

        let liaisons = [];
        if (fournisseurToAdd.fournisseurCopie) {

            let fournisseursDepotsCopie = fournisseursDepotsQuery.data.fournisseursDepots.filter(fd => fd.fournisseurId === fournisseurToAdd.fournisseurCopie.id);

            liaisons = depotsQuery.data.map(depot => {

                let depotCopie = fournisseursDepotsCopie.find(fdc => fdc.codeDepot === depot.codeDepot);
                let liaison = {
                    depot: depot,
                    numeroCompte: '',
                    email: depotCopie ? depotCopie.email : ''
                };
                return liaison;
            });
        }
        else {
            liaisons = depotsQuery.data.map(depot => {
                let liaison = {
                    depot: depot,
                    numeroCompte: '',
                    email: ''
                };
                return liaison;
            });
        }

        newFournisseurToAdd.liaisons = liaisons;

        //console.log("handleAddFournisseurStep3 newFournisseurToAdd", newFournisseurToAdd);

        setFournisseurToAdd(newFournisseurToAdd);

    };

    const handleChangeNewNumeroCompte = ({ codeDepot, newNumeroCompte }) => {

        let t0 = performance.now(); //start time

        console.log('handleChangeNewNumeroCompte', codeDepot, newNumeroCompte);
        let newFournisseurToAdd = {
            ...fournisseurToAdd,
            liaisons: fournisseurToAdd.liaisons.map(l => l.depot.codeDepot === codeDepot ? {
                ...l,
                numeroCompte: newNumeroCompte
            } : l)
        };
        let t1 = performance.now(); //end time

        console.log('Time taken to execute function:' + (t1 - t0) + ' milliseconds');
        setFournisseurToAdd(newFournisseurToAdd);
    };

    const handleChangeNewEmail = ({ codeDepot, newEmail }) => {


        let t0 = performance.now(); //start time

        let newFournisseurToAdd = {
            ...fournisseurToAdd,
            liaisons: fournisseurToAdd.liaisons.map(l => l.depot.codeDepot === codeDepot ? {
                ...l,
                email: newEmail
            } : l)
        };
        setFournisseurToAdd(newFournisseurToAdd);
    };


    if (fournisseursDepotsQuery.isLoading || depotsQuery.isLoading) {

        let headers = ["Fournisseur", "Code agence", "Dépôt", "Numéro de compte", "Email", "Actions"];

        return (
            <SkeletonTable headers={headers} />
        );
    }

    if (fournisseursDepotsQuery.error || depotsQuery.error) {
        return (<p>Erreur du chargement des liaisons fournisseur/dépots, veuillez contacter le support.</p>);
    }


    if (!fournisseursDepotsQuery.data || !depotsQuery.data) {
        return null;
    }

    //console.log("render");

    return (
        <>
            <Table size='small'>
                <TableHead sx={{ backgroundColor: 'background.default' }}>
                    <TableRow>
                        <TableCell>
                            <Button variant="outlined" endIcon={<MoreVertIcon />}
                                onClick={openMenuFournisseur}
                            >
                                Fournisseur
                            </Button>
                            {fournisseurFiltre && (
                                <Chip sx={{ marginLeft: '8px' }} label={`${fournisseurFiltre.code} - ${fournisseurFiltre.nom}`} variant="outlined" onDelete={() => setFournisseurFiltre(null)} />
                            )}
                        </TableCell>

                        <TableCell>Code agence</TableCell>

                        <TableCell>
                            <Button variant="outlined" endIcon={<MoreVertIcon />}
                                onClick={openMenuDepot}
                            >
                                Dépôt
                            </Button>
                            {depotFiltre && (
                                <Chip sx={{ marginLeft: '8px' }} label={`${depotFiltre.codeDepot} - ${depotFiltre.nom}`} variant="outlined" onDelete={() => setDepotFiltre(null)} />
                            )}
                        </TableCell>

                        <TableCell>Numéro de compte</TableCell>

                        <TableCell>Email</TableCell>

                        <TableCell style={actionsCellStyle}>Actions</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <>
                        {
                            fournisseursDepots.map(fd => {

                                let edition = edited !== null && fd.fournisseur.id === edited.fournisseur.id && fd.depot.codeDepot === edited.depot.codeDepot;

                                let showActions = edited.fournisseur.id === 0;

                                let emailsDepot = []; // A voir comment mémoriser
                                if (edition) {
                                    emailsDepot = fournisseursDepotsQuery.data.fournisseursDepots
                                        .filter(fd => fd.codeDepot === edited.depot.codeDepot && fd.email)
                                        .map(fd => fd.email)
                                        .filter((value, index, self) => self.indexOf(value) === index) // Unicité
                                        .map(fd => { return { email: fd }; });
                                }

                                return (
                                    <TableRow hover sx={showActions ? { "&:hover .MuiTableCell-root:last-child *:first-of-type": { display: 'inherit' } } : {}} key={fd.fournisseur.id + "_" + fd.depot.codeDepot}>

                                        <TableCell>
                                            {fd.fournisseur.code} - {fd.fournisseur.nom}
                                        </TableCell>

                                        <TableCell>
                                            {!edition &&
                                                <>{fd.codeAgence}</>
                                            }

                                            {edition && (
                                                <QualificationTextField
                                                    size="small"
                                                    autoFocus
                                                    style={{ paddingBottom: '0px' }}
                                                    value={edited.newCodeAgence}
                                                    onChange={e => setEdited({ ...edited, newCodeAgence: e.target.value })}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {fd.depot.codeDepot} - {fd.depot.nom}
                                        </TableCell>

                                        <TableCell>
                                            {!edition && (
                                                <>{fd.numeroCompte}</>
                                            )}

                                            {edition && (
                                                <QualificationTextField
                                                    size="small"
                                                    autoFocus
                                                    style={{ paddingBottom: '0px' }}
                                                    value={edited.newNumeroCompte}
                                                    helperText={editedValid.numeroCompteHelperText}

                                                    error={!!editedValid.numeroCompteHelperText}

                                                    onChange={e => setEdited({ ...edited, newNumeroCompte: e.target.value })}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {!edition && (
                                                <>
                                                    {fd.email}
                                                </>
                                            )}

                                            {edition && (

                                                <Autocomplete
                                                    forcePopupIcon={true}
                                                    value={edited.newEmail}
                                                    onChange={(event, newValue) => {
                                                        if (typeof newValue === 'string') {
                                                            setEditedMail({
                                                                email: newValue,
                                                            });
                                                        } else if (newValue && newValue.inputValue) {
                                                            // Create a new value from the user input
                                                            setEditedMail({
                                                                email: newValue.inputValue,
                                                            });
                                                        } else {
                                                            setEditedMail(newValue);
                                                        }
                                                    }}
                                                    filterOptions={(options, params) => {
                                                        const filtered = filter(options, params);

                                                        const { inputValue } = params;
                                                        // Suggest the creation of a new value
                                                        const isExisting = options.some((option) => inputValue === option.email);
                                                        if (inputValue !== '' && !isExisting) {
                                                            filtered.push({
                                                                inputValue,
                                                                email: `Ajouter "${inputValue}"`,
                                                            });
                                                        }

                                                        return filtered;
                                                    }}
                                                    selectOnFocus
                                                    clearOnBlur
                                                    handleHomeEndKeys
                                                    options={emailsDepot}
                                                    getOptionLabel={(option) => {
                                                        // Value selected with enter, right from the input
                                                        if (typeof option === 'string') {
                                                            return option;
                                                        }
                                                        // Add "xxx" option created dynamically
                                                        if (option.inputValue) {
                                                            return option.inputValue;
                                                        }
                                                        // Regular option
                                                        return option.email;
                                                    }}
                                                    renderOption={(props, option) => <li {...props}>{option.email}</li>}
                                                    freeSolo
                                                    fullWidth
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            size="small"
                                                            helperText={editedValid.emailHelperText}

                                                            error={!!editedValid.emailHelperText || !!edited.newEmail}
                                                        />
                                                    )}
                                                />
                                            )}

                                        </TableCell>

                                        <TableCell sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                            <Box sx={!edition ? { display: 'none' } : {}}>
                                                {!edition && (
                                                    <>
                                                        <IconButton
                                                            sx={{ paddingTop: '0px', paddingBottom: '0px' }}
                                                            onClick={() => startEdition(fd)}
                                                            disabled={saving}
                                                            size="small"
                                                        >
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton
                                                            sx={{ paddingTop: '0px', paddingBottom: '0px' }}
                                                            onClick={() => handleRemovalFournisseurDepot(fd)}
                                                            disabled={saving} size="small">
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </>
                                                )}

                                                {edition && (
                                                    <>
                                                        {!saving && (
                                                            <>
                                                                <IconButton
                                                                    onClick={() => setEdited(defaultFournisseurDepot)}
                                                                    color="error">
                                                                    <CancelIcon />
                                                                </IconButton>
                                                                <IconButton
                                                                    onClick={validEdition}
                                                                    color="success"
                                                                    disabled={!editedValid.email || !editedValid.numeroCompte}>
                                                                    <CheckCircleIcon />
                                                                </IconButton>
                                                            </>
                                                        )}

                                                        {saving && (<CircularProgress color="secondary" size={16} />)}
                                                    </>
                                                )}

                                            </Box>

                                        </TableCell>

                                    </TableRow>
                                );
                            })
                        }
                    </>
                </TableBody>
            </Table>

            <Menu
                anchorEl={anchorMenuFournisseur}
                open={menuFournisseurOpen}
                onClose={closeMenuFournisseur}
            >
                <MenuItem onClick={closeMenuFournisseur}>

                    <TextField
                        select
                        label="Filtrer sur un fournisseur"
                        value={fournisseurFiltre ? fournisseurFiltre.id : ''}
                        onChange={e => setFournisseurFiltre(fournisseursDepotsQuery.data.fournisseurs.find(f => f.id === e.target.value))}
                        fullWidth
                        sx={{ minWidth: '300px' }}
                        size="small"
                    >
                        {fournisseursDepotsQuery.data.fournisseurs.map(fournisseur => (
                            <MenuItem key={fournisseur.id} value={fournisseur.id}>
                                {fournisseur.code} - {fournisseur.nom}
                            </MenuItem>
                        ))}
                    </TextField>

                </MenuItem>


                <MenuItem onClick={closeMenuFournisseur}>
                    <Button color="success" variant="contained" sx={{ minWidth: '120px' }} onClick={() => { setAddFournisseurDialogOpen(true); }}>Ajouter</Button>
                </MenuItem>
                <MenuItem onClick={closeMenuFournisseur}>
                    <Button color="error" variant="outlined" sx={{ minWidth: '120px' }} onClick={() => { setRemoveFournisseurDialogOpen(true); }}>Supprimer</Button>
                </MenuItem>
            </Menu>

            <Menu
                anchorEl={anchorMenuDepot}
                open={menuDepotOpen}
                onClose={closeMenuDepot}
            >
                <MenuItem onClick={closeMenuDepot}>

                    <TextField
                        select
                        label="Filtrer sur un dépôt"
                        value={depotFiltre ? depotFiltre.codeDepot : ''}
                        onChange={handeChangeDepotFiltre}
                        fullWidth
                        sx={{ minWidth: '300px' }}
                        size="small"
                    >
                        {depotsQuery.data.map(depot => (
                            <MenuItem key={depot.codeDepot} value={depot.codeDepot}>
                                {depot.codeDepot} - {depot.nom}
                            </MenuItem>
                        ))}
                    </TextField>


                </MenuItem>
                <MenuItem onClick={closeMenuDepot}>
                    <FormControlLabel control={<Checkbox checked={tousDepots} onChange={handeChangeTousDepot} />} label="Afficher tous les dépôts" />
                </MenuItem>
                <MenuItem onClick={closeMenuDepot}>
                    <FormControlLabel control={<Checkbox checked={manquants} onChange={handeChangeManquants} />} label="Uniquement les dépôts manquants" />
                </MenuItem>
            </Menu>


            {removeFournisseurDialogOpen && (

                <Dialog open>

                    <DialogTitle>Administration du SAV By Foussier</DialogTitle>

                    <DialogContent>

                        <Stack spacing={1}>

                            <Typography>
                                Attention, cette action supprimera le fournisseur du SAV by Foussier
                            </Typography>


                            <TextField
                                required
                                select
                                label="Sélectionner le fournisseur à supprimer"
                                value={fournisseurToRemove ? fournisseurToRemove.id : ''}
                                onChange={e => setFournisseurToRemove(fournisseursDepotsQuery.data.fournisseurs.find(f => f.id === e.target.value))}
                                fullWidth
                                sx={{ minWidth: '300px' }}
                            >
                                {fournisseursDepotsQuery.data.fournisseurs.map(fournisseur => (
                                    <MenuItem key={fournisseur.id} value={fournisseur.id}>
                                        {fournisseur.code} - {fournisseur.nom}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Stack>


                    </DialogContent>

                    <DialogActions>

                        <Button
                            variant="outlined"
                            onClick={() => { setRemoveFournisseurDialogOpen(false); setFournisseurToRemove(null); }}
                            disabled={saving}
                        >
                            Annuler
                        </Button>


                        <LoadingButton
                            pending={saving}
                            disabled={!fournisseurToRemove}
                            color="secondary"
                            variant="contained"
                            onClick={handleRemovalFournisseur}
                            label="Supprimer"
                        />


                    </DialogActions>

                </Dialog>

            )}


            {addFournisseurDialogOpen && (

                <Dialog open fullWidth={fournisseurToAdd && fournisseurToAdd.step === 3} maxWidth="xl">

                    <DialogTitle>{`Administration du SAV By Foussier - Ajout d'un fournisseur ${fournisseurToAdd && fournisseurToAdd.step === 3 ? " : " + fournisseurToAdd.code + " - " + fournisseurToAdd.nom : ""}`}</DialogTitle>

                    <DialogContent>
                        <Stack mt={1} spacing={1}>

                            {(!fournisseurToAdd || fournisseurToAdd.step === 1) && (

                                <FournisseurGestionAutocomplete
                                    onChange={handleChangeFournisseurToAdd}
                                    autoFocus
                                    error={fournisseurToAdd && fournisseurToAdd.error}
                                    helperText={fournisseurToAdd && fournisseurToAdd.error ? "Fournisseur déjà configuré pour le SAV By Foussier" : ""}
                                    autoriseSAV
                                />
                            )}


                            {fournisseurToAdd && fournisseurToAdd.step === 2 && (
                                <>
                                    <TextField
                                        disabled
                                        label="Fournisseur"
                                        value={`${fournisseurToAdd.code} - ${fournisseurToAdd.nom}`}
                                    />

                                    <FormControl>
                                        <FormLabel>Voulez-vous copier les mails d'un autre fournisseur ?</FormLabel>
                                        <RadioGroup row value={fournisseurToAdd.copier} onChange={e => { setFournisseurToAdd({ ...fournisseurToAdd, copier: e.target.value, fournisseurCopie: null }); }}>
                                            <FormControlLabel value="1" control={<Radio />} label="Oui" />
                                            <FormControlLabel value="0" control={<Radio />} label="Non" />
                                        </RadioGroup>
                                    </FormControl>

                                    {fournisseurToAdd.copier === "1" && (

                                        <TextField
                                            select
                                            label="Copier les mails du fournisseur"
                                            value={fournisseurToAdd.fournisseurCopie ? fournisseurToAdd.fournisseurCopie.id : ''}
                                            onChange={e => setFournisseurToAdd({ ...fournisseurToAdd, fournisseurCopie: fournisseursDepotsQuery.data.fournisseurs.find(f => f.id === e.target.value) })}
                                            fullWidth
                                            sx={{ minWidth: '300px' }}
                                            size="small"
                                            autoFocus
                                        >
                                            {fournisseursDepotsQuery.data.fournisseurs.map(fournisseur => (
                                                <MenuItem key={fournisseur.id} value={fournisseur.id}>
                                                    {fournisseur.code} - {fournisseur.nom}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                </>
                            )}



                            {fournisseurToAdd && fournisseurToAdd.step === 3 && (

                                <Table size='small'>
                                    <TableHead sx={{ backgroundColor: 'background.default' }}>
                                        <TableRow>
                                            <TableCell>Dépôt</TableCell>
                                            <TableCell>Numéro de compte</TableCell>
                                            <TableCell>Email</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <>

                                            {
                                                fournisseurToAdd.liaisons.map((liaison, index) => {


                                                    return (
                                                        <TableRow hover key={liaison.depot.codeDepot}>
                                                            <TableCell>
                                                                {liaison.depot.codeDepot} - {liaison.depot.nom}
                                                            </TableCell>


                                                            <TableCell style={{ paddingBottom: '0px', paddingTop: '0px', borderBottomWidth: '0px' }}>

                                                                <QualificationTextField
                                                                    size="small"
                                                                    autoFocus={index === 0}
                                                                    value={liaison.numeroCompte}
                                                                    style={{ paddingBottom: '0px' }}
                                                                    inputProps={{
                                                                        style: {
                                                                            paddingTop: '4px',
                                                                            paddingBottom: '4px'
                                                                        }
                                                                    }}
                                                                    disabled={saving}

                                                                    helperText={""}

                                                                    error={false}

                                                                    onChange={e => handleChangeNewNumeroCompte({ codeDepot: liaison.depot.codeDepot, newNumeroCompte: e.target.value })}
                                                                />


                                                            </TableCell>


                                                            <TableCell style={{ paddingBottom: '0px', paddingTop: '0px', borderBottomWidth: '0px' }}>

                                                                <QualificationTextField
                                                                    size="small"
                                                                    autoFocus={false}
                                                                    value={liaison.email}
                                                                    style={{ paddingBottom: '0px' }}
                                                                    inputProps={{
                                                                        style: {
                                                                            paddingTop: '4px',
                                                                            paddingBottom: '4px'
                                                                        }
                                                                    }}
                                                                    disabled={saving}

                                                                    helperText={""}

                                                                    error={false}

                                                                    onChange={e => handleChangeNewEmail({ codeDepot: liaison.depot.codeDepot, newEmail: e.target.value })}
                                                                />

                                                            </TableCell>


                                                        </TableRow>
                                                    );
                                                })
                                            }


                                        </>
                                    </TableBody>
                                </Table>

                            )}



                        </Stack>

                    </DialogContent>

                    <DialogActions>

                        {(!fournisseurToAdd || fournisseurToAdd.step === 1 || fournisseurToAdd.step === 2) && (

                            <Button
                                variant="outlined"
                                onClick={() => { setAddFournisseurDialogOpen(false); setFournisseurToAdd(null); }}
                                disabled={saving}
                            >
                                Annuler
                            </Button>
                        )}

                        {fournisseurToAdd && fournisseurToAdd.step === 1 && (

                            <Button
                                variant="outlined"
                                onClick={() => { setFournisseurToAdd(null); }}
                                disabled
                            >
                                précédent
                            </Button>
                        )}
                        {fournisseurToAdd && fournisseurToAdd.step === 2 && (

                            <Button
                                variant="outlined"
                                onClick={() => { setFournisseurToAdd(null); }}
                            >
                                précédent
                            </Button>
                        )}





                        {(!fournisseurToAdd || fournisseurToAdd.step === 1) && (

                            <Button
                                variant="contained"
                                onClick={() => { setFournisseurToAdd({ ...fournisseurToAdd, step: fournisseurToAdd.step + 1 }); }}
                                disabled={!fournisseurToAdd || fournisseurToAdd.error}
                            >
                                suivant
                            </Button>
                        )}

                        {fournisseurToAdd && fournisseurToAdd.step === 2 && (
                            <Button
                                variant="contained"
                                onClick={handleAddFournisseurStep3}
                                disabled={fournisseurToAdd.copier === '' || (fournisseurToAdd.copier === '1' && fournisseurToAdd.fournisseurCopie === null)}
                            >
                                suivant
                            </Button>
                        )}


                        {fournisseurToAdd && fournisseurToAdd.step === 3 && (

                            <LoadingButton
                                pending={saving}
                                disabled={!fournisseurToAddValid}
                                color="secondary"
                                variant="contained"
                                onClick={handleAdding}
                                label="Sauvegarder"
                            />
                        )}

                    </DialogActions>

                </Dialog>

            )}
        </>
    );
}

const mapDispatchToProps = {
    postSAVFournisseurDepot,
    postSAVFournisseurDepots,
    deleteSAVFournisseurDepot,
    deleteSAVFournisseurDepots
};

export default connect(null, mapDispatchToProps)(FournisseursDepots);